import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';

export default function Broadcast_Render(props) {
  const { setNodeData, nodeData} = props;
  const [speeds, ] = useState(["default", "x-slow", "slow", "medium", "fast", "x-fast"]);
  const [message, setMessage] = useState(nodeData.type === "broadcast"? nodeData.message: "");
  const [speed, setSpeed] = useState(nodeData.type === "broadcast"? nodeData.speed: speeds[0]);

  setNodeData({
    type: "broadcast",
    message: message,
    speed: speed
  })
  const handleChangeMessage = (event) => {
    setMessage(event.target.value)
    setNodeData({
        type: "broadcast",
        message: event.target.value,
        speed: speed
    })
  }
  const handleChangeSpeed = (event) => {
    setSpeed(event.target.value)
    setNodeData({
        type: "broadcast",
        message: message,
        speed: event.target.value
    })
  }
  return(<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <TextField
      id="outlined-required"
      label="Message"
      value={message}
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChangeMessage}
    >
    </TextField>
    <TextField
        select
        id="outlined-required"
        label="Speed"
        defaultValue={speed}
        value={speed}
        name="robot_actions"
        style={{width: "100%"}}
        onChange={handleChangeSpeed}
      >
      {speeds.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
  </Grid>
  )
}